var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      _a$color = a.color,
      d = _a$color === void 0 ? "#130754" : _a$color,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    }, d ? {
      fill: d
    } : {})
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      InkscapeStroke: "none"
    },
    d: "M16.25 112.609c-2.238 0-4.513-.925-5.941-2.739v9.796H5.833v-24.18h4.049l.159 2.651c1.389-2.044 3.857-3.124 6.21-3.121 4.511 0 7.838 3.779 7.838 8.795 0 5.015-3.329 8.801-7.84 8.799zm-1.387-14.27c-2.613 0-4.746 2.044-4.746 5.477 0 3.433 2.12 5.477 4.744 5.477 2.623 0 4.739-2.044 4.739-5.477 0-3.433-2.116-5.477-4.737-5.477zm26.095 13.811l-.155-2.66c-1.388 2.043-3.857 3.123-6.208 3.123-4.513 0-7.837-3.781-7.837-8.795 0-5.013 3.317-8.795 7.837-8.792 2.35 0 4.82 1.088 6.208 3.123l.155-2.66h4.05v16.663zm-4.974-13.81c-2.613 0-4.744 2.044-4.744 5.477 0 3.433 2.12 5.477 4.744 5.477 2.623 0 4.743-2.044 4.743-5.475 0-3.43-2.12-5.466-4.743-5.479zm24.678 13.814v-9.228c0-3.24-1.12-4.32-3.163-4.32-2.12 0-4.435 1.927-4.437 4.241v9.296H48.59V95.489h4.1l.191 3.087c1.12-2.122 3.627-3.548 6.172-3.548 4.434 0 6.095 3.087 6.095 7.214v9.912zm20.877.002l-.155-2.662c-1.387 2.044-3.855 3.123-6.209 3.123-4.512 0-7.837-3.78-7.837-8.794 0-5.014 3.318-8.793 7.837-8.793 2.236 0 4.513.927 5.94 2.74v-8.755h4.473v23.141zm-4.972-13.802c-2.624 0-4.746 2.044-4.746 5.477 0 3.433 2.12 5.475 4.743 5.478 2.624 0 4.744-2.045 4.744-5.478s-2.12-5.477-4.741-5.477zm25.833 13.804l-.154-2.66c-1.389 2.044-3.858 3.124-6.209 3.122-4.513 0-7.837-3.78-7.837-8.793 0-5.014 3.318-8.795 7.837-8.793 2.351 0 4.82 1.089 6.209 3.124l.155-2.66h4.06v16.66zm-4.974-13.804c-2.623 0-4.743 2.044-4.743 5.477 0 3.433 2.12 5.478 4.743 5.478s4.744-2.045 4.744-5.478-2.12-5.477-4.744-5.477zm18.938 14.346a13.094 13.094 0 01-6.673-1.89l.732-3.095c1.35.81 3.394 1.853 5.862 1.853 1.774 0 3.009-.54 3.009-1.93 0-1.194-1.272-1.619-3.549-2.159-4.086-.888-5.553-3.047-5.551-5.4 0-2.613 2.044-5.09 6.557-5.09 2.739 0 5.129 1.197 5.66 1.504l-.725 2.95a9.692 9.692 0 00-4.82-1.39c-1.813 0-2.701.617-2.701 1.62 0 1.117 1.158 1.62 2.932 2.044 4.395.926 6.17 2.97 6.17 5.208 0 3.579-2.624 5.775-6.903 5.775zM53.942 16.057h7.947V32.56h-7.947zm0 33.898h7.947v16.502h-7.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      InkscapeStroke: "none"
    },
    d: "M53.942 37.379h7.947v7.786h-7.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      InkscapeStroke: "none"
    },
    d: "M41.175 29.626h7.947V84.48h-7.947zm25.27 33.944h7.948v16.502h-7.948zm0-33.924h7.948v16.502h-7.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      InkscapeStroke: "none"
    },
    d: "M66.445 50.965h7.948v7.785h-7.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      InkscapeStroke: "none"
    },
    d: "M78.945 11.762h7.948v54.853h-7.948z"
  }));
};